import controller from './thing-location.controller';

const template = require('./thing-location.html');

export default {
    bindings: {
        reset: '<',
        addItemToBucket: '&',
        removeItemFromBucket: '&'
    },
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/advanced/thing-location/thing-location.component.js